import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { ParkingPointsOfInterest } from 'src/features/parkingManagement/types/parking';

const RESOURCE = '/parkings/:parkingId/point-of-interest-distances/';

interface DTO {
    parkingId: string;
}

export type PointOfInterestDistance = {
    point_of_interest: ParkingPointsOfInterest;
    distance: string | null;
};

export type ParkingPointOfInterest = {
    point_of_interest_distances: PointOfInterestDistance[];
};

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId }: DTO): Promise<ParkingPointOfInterest> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetParkingPointOfInterest };
